export default __webpack_public_path__ + "static/media/Solution_BG_Small.02d9cd42.png";